import { ILogFromServer, ILogRow } from 'interfaces/logRow.interface';
import { IOrchestrationSidePanelSteps } from 'interfaces/orchestrationDiagram/orchestrationDiagram.interface';
import { NO_STEP_NAME_AVAILABLE } from 'utils/common-constants';
import { DateUtils } from 'utils/dateUtils/DateUtils';

const isNumeric = (str: string) => {
  return !isNaN(parseFloat(str));
};

const sortLogs = (logs: ILogRow[]) => {
  return logs.sort((a: any, b: any) => {
    const stepNameA = a['Step name'];
    const stepNameB = b['Step name'];
    const indexA = stepNameA.split(' ')[0];
    const indexB = stepNameB.split(' ')[0];

    if (indexA === 'No' && indexB !== 'No') {
      return -1;
    }
    if (indexB === 'No' && indexA !== 'No') {
      return 1;
    }

    if (isNumeric(indexA) && isNumeric(indexB)) {
      return parseInt(indexA) - parseInt(indexB);
    }

    if (isNumeric(indexA) && !isNumeric(indexB)) {
      return -1;
    }
    if (!isNumeric(indexA) && isNumeric(indexB)) {
      return 1;
    }

    if (!isNumeric(indexA) && !isNumeric(indexB)) {
      return indexA.localeCompare(indexB);
    }

    return 0;
  });
};

export const objectFromLogData = (
  log: ILogFromServer[],
  steps?: IOrchestrationSidePanelSteps[],
  overallCreatedTime?: string
): ILogRow[] => {
  const transformedLog = log.map((item: ILogFromServer, index: number) => {
    return {
      createdTime: item.timestamp ?? '-',
      severity: item.logLevel ?? 'INFO',
      'Step name': item.metadata?.CSBWorkflowStepName
        ? `${getStepIndex(steps, item.metadata.CSBJobStepId)}  ${
            item.metadata?.CSBWorkflowStepName
          }`
        : NO_STEP_NAME_AVAILABLE,
      message: item.message ?? '-',
      index,
      overallCreatedTime,
      hasStackTrace:
        item.stackTrace && item.stackTrace !== 'null' ? true : false,
      metadata: {
        CSBJobId: item.metadata?.CSBJobId ?? '',
      },
    } as ILogRow;
  });

  return sortLogs(transformedLog);
};

const getStepIndex = (
  steps?: IOrchestrationSidePanelSteps[],
  jobStepId?: string
): string => {
  const currentStep = steps?.find(
    (instanceStep) => instanceStep.jobStepId === Number(jobStepId)
  )?.index;
  if (currentStep) {
    return currentStep;
  }
  return '';
};
